
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import global from '../../../static/js/global.js'
export default{
data(){
return {
code:'',
state:'',
openId:'',
userObj:{},
wechatJson:{},
messageWarn:'',
username:'',
password:'',
disabledFlag: false,
bindState: false,
pageTitle: '账号绑定'
}
},
components: {
XHeader,
XInput,
Group,
XButton
},
mounted: function(){
this.code = this.$router.history.current.query.code;
this.state = this.$router.history.current.query.state;
let url = global.host + 'sysUser/getUser?code='+this.code + '&state=' + this.state + "&corpid=" + global.wechat.corpid + "&corpsecret=" + global.wechat.corpsecret;
this.$http.get(url).then(function(res){
if(res.body.statusCode == '200'){
this.bindState = true;
this.pageTitle = '绑定信息';
this.userObj = res.body.result.userObj;
this.openId = res.body.result.openId;
this.wechatJson.openId = res.body.result.openId;
this.wechatJson.nickName = res.body.result.nickName;
this.wechatJson.headImgUrl = res.body.result.headImgUrl;
} else if(res.body.statusCode == '404'){
this.bindState = false;
this.openId = res.body.result.openId;
this.wechatJson.openId = res.body.result.openId;
this.wechatJson.nickName = res.body.result.nickName;
this.wechatJson.headImgUrl = res.body.result.headImgUrl;
} else {
this.bindState = false;
this.messageWarn = res.body.message;
}
},function(err){
this.messageWarn = '服务网络异常，请稍后重试';
console.log(err);
});
},
methods:{
submitData(handleDesc){
let data = new Object();
if(handleDesc=='bind'){
if(!this.username){
this.messageWarn ='请输入账号';
return false;
}
if(!this.password){
this.messageWarn ='请输入密码';
return false;
}
if(!this.openId){
this.messageWarn ='openId无效';
return false;
}
data.openId = this.openId;
} else {
data.openId = "";
this.username = this.userObj.userId;
this.password = "";
}
this.disabledFlag = true;
data.handleDesc = handleDesc;
data.userId = this.username;
data.userPass = this.password;
data.wechatJson = JSON.stringify(this.wechatJson);
this.$http.post(global.host + 'sysUser/bindUser',data).then(function(res){
this.disabledFlag = false;
if(res.body.statusCode == '200'){
if(handleDesc=='bind'){
this.bindState = true;
this.pageTitle = '绑定信息';
}else{
this.bindState = false;
this.pageTitle = '账号绑定';
}
this.userObj = res.body.result;
} else {
this.messageWarn = res.body.message;
}
},function(err){
this.disabledFlag = false;
this.messageWarn = '服务网络异常，请稍后重试';
console.log(err);
});
}
}
}



// WEBPACK FOOTER //
// ./src/components/beforelogin/bindSysUser.vue